import { smallLabelTypographicStyle } from "@/lib/styles/helpers";
import styled, { css } from "styled-components";
import { CardContainer, ImageContainer } from "../styles";

export const ImageContainerGallery = styled(ImageContainer)<{
  $paddingTop?: number;
}>`
  background-color: lightgray;
  padding-top: ${({ $paddingTop }) =>
    $paddingTop ? `${$paddingTop}%` : "61%"};

  img {
    opacity: 0;
    transition: transform 0.1s ease-in, opacity 0.8s ease-in;

    &:hover {
      transform: scale(1.1);
    }
    ${({ $isLoaded }) =>
      $isLoaded &&
      css`
        opacity: 1;
      `}
  }
`;

export const CardContainerGallery = styled(CardContainer)`
  gap: 24px;
  background-color: ${({theme})=> theme.colors.white};
`;

export const Description = styled.div`
  ${smallLabelTypographicStyle}
  font-weight: 400;
`;
